
  Vue.component('abb-menu-item', {
    props: {
      Id: Number,
      Label: { default: 'Standard', type: String },
      Description: { default: '', type: String },
      Selected: { type: Boolean, default: false },
      Amount: { type: Number, default: 0 },
      Duration: { type: Number, default: 0 },
      OriginalAmount: { type: Number, default: 0 },
      Recommended: { type: Boolean, default: false },
      MustHaveWidget: { type: Boolean, default: false },
      WidgetOnly: { type: Boolean, default: false },
      DemoMode: { type: Boolean, default: false },
      ColumnsNumber: { type: Number, default: 3 },
      SpecialOffer: { type: Boolean, default: false },
      ShowPaymentInstallment: { type: Boolean, default: false },
      OnlyOne: { type: Boolean, default: false },
      HandlePaymentInstallment: { type: Function }
    },
    data() {
      return {
        showFooter: false
      }
    },
    template: '#abb-menu-item',
    computed: {
      PaymentInstallment() {
        return this.Duration === 5
      },
      Periodicity() {
        return this.Duration === 5 ? 'al mese' : `all'anno`
      },
      title() {
        let retVal = ''
        if (this.Amount < 0) {
          retVal = 'SOLO REGISTRAZIONE'
        } else if (this.MustHaveWidget) {
          retVal = 'ABBONAMENTO ANNUALE PREMIUM'
        } else if (this.WidgetOnly) {
          retVal = 'WIDGET'
        } else {
          retVal = 'ABBONAMENTO ANNUALE STANDARD'
        }
        return retVal
      },
      featuresList() {
        let retVal = []
        const premiumList = [
          { id: 0, label: 'Naviga nel ricchissimo database di LearK' },
          { id: 10, label: 'Ottieni e sfrutta il widget personalizzato' },
          { id: 20, label: 'Raccogli i CV in modo organizzato, in cloud' },
          { id: 30, label: 'Gestisci la privacy dei CV' },
          { id: 40, label: 'Agevola i processi di selezione del personale' },
          { id: 50, label: 'Contribuisci a efficientare il sistema e migliorare il servizio' },
          { id: 60, label: 'Funzione liste: visualizza e raggruppa i CV simili ' },
          { id: 70, label: 'Funzione radar: ricevi una notifica per ogni profilo affine' }
        ]
        const widgetOnlyList = [
          { id: 10, label: 'Raccogli i CV in modo organizzato, in cloud' },
          { id: 10, label: 'Gestisci la privacy dei CV' },
          { id: 10, label: 'Agevola i processi di selezione del personale' },
          { id: 10, label: 'Si integra con il tuo sito, i social e ovunque online' },
          { id: 10, label: 'Contribuisci a efficientare il sistema e migliorare il servizio ' }
        ]

        if (this.WidgetOnly) {
          retVal = [...widgetOnlyList]
        } else {
          retVal = [...premiumList]
        }

        return retVal.sort((a, b) => (a.id < b.id ? -1 : 1))
      }
    },
    watch: {},
    methods: {
      toggleFooter(e) {
        console.log(e)
        this.showFooter = !this.showFooter
      }
    },
    mounted() {}
  })
